// Utilitário centralizado para mapeamento de ícones de tags
// Este arquivo centraliza o mapeamento de ícones para evitar inconsistências

export const getTagIcon = (iconName) => {
  
  // Lista completa de ícones disponíveis (igual ao TagIconSelector.vue)
  const availableIcons = [
    // Prioridade e Status
    { value: 'priority', emoji: '🔥' },
    { value: 'urgent', emoji: '⚡' },
    { value: 'important', emoji: '⭐' },
    { value: 'critical', emoji: '🚨' },
    { value: 'high', emoji: '🔴' },
    { value: 'medium', emoji: '🟡' },
    { value: 'low', emoji: '🟢' },
    { value: 'done', emoji: '✅' },
    { value: 'pending', emoji: '⏳' },
    { value: 'blocked', emoji: '🚫' },
    { value: 'progress', emoji: '🔄' },
    { value: 'review', emoji: '👀' },
    { value: 'approval', emoji: '👍' },
    { value: 'rejection', emoji: '👎' },
    { value: 'warning', emoji: '⚠️' },
    { value: 'error', emoji: '❌' },
    { value: 'success', emoji: '🎉' },
    { value: 'info', emoji: 'ℹ️' },
    { value: 'question', emoji: '❓' },
    { value: 'help', emoji: '🆘' },
    
    // Trabalho e Produtividade
    { value: 'task', emoji: '📋' },
    { value: 'project', emoji: '📁' },
    { value: 'bug', emoji: '🐛' },
    { value: 'feature', emoji: '✨' },
    { value: 'improvement', emoji: '🔧' },
    { value: 'test', emoji: '🧪' },
    { value: 'deploy', emoji: '🚀' },
    { value: 'release', emoji: '🎊' },
    { value: 'maintenance', emoji: '🔨' },
    { value: 'security', emoji: '🔒' },
    { value: 'database', emoji: '🗄️' },
    { value: 'api', emoji: '🔌' },
    { value: 'frontend', emoji: '🎨' },
    { value: 'backend', emoji: '⚙️' },
    { value: 'mobile', emoji: '📱' },
    { value: 'web', emoji: '🌐' },
    { value: 'desktop', emoji: '💻' },
    
    // Comunicação e Colaboração
    { value: 'meeting', emoji: '📅' },
    { value: 'call', emoji: '📞' },
    { value: 'email', emoji: '📧' },
    { value: 'chat', emoji: '💬' },
    { value: 'team', emoji: '👥' },
    { value: 'client', emoji: '👤' },
    { value: 'admin', emoji: '👑' },
    { value: 'manager', emoji: '👔' },
    { value: 'developer', emoji: '👨‍💻' },
    { value: 'designer', emoji: '🎨' },
    { value: 'analyst', emoji: '📊' },
    { value: 'consultant', emoji: '💼' },
    { value: 'support', emoji: '🆘' },
    { value: 'training', emoji: '🎓' },
    { value: 'documentation', emoji: '📚' },
    { value: 'tutorial', emoji: '📖' },
    { value: 'guide', emoji: '🗺️' },
    { value: 'manual', emoji: '📘' },
    
    // Tempo e Organização
    { value: 'clock', emoji: '⏰' },
    { value: 'calendar', emoji: '📆' },
    { value: 'deadline', emoji: '⏳' },
    { value: 'reminder', emoji: '🔔' },
    { value: 'event', emoji: '🎯' },
    { value: 'milestone', emoji: '🏁' },
    { value: 'checkpoint', emoji: '📍' },
    { value: 'phase', emoji: '📈' },
    { value: 'sprint', emoji: '🏃‍♂️' },
    { value: 'quarter', emoji: '📅' },
    { value: 'monthly', emoji: '📅' },
    { value: 'weekly', emoji: '📅' },
    { value: 'daily', emoji: '📅' },
    
    // Finanças e Negócios
    { value: 'money', emoji: '💰' },
    { value: 'budget', emoji: '💳' },
    { value: 'cost', emoji: '💸' },
    { value: 'revenue', emoji: '💵' },
    { value: 'profit', emoji: '📈' },
    { value: 'investment', emoji: '📊' },
    { value: 'sales', emoji: '🛒' },
    { value: 'marketing', emoji: '📢' },
    { value: 'promotion', emoji: '🎯' },
    { value: 'campaign', emoji: '📢' },
    { value: 'lead', emoji: '🎣' },
    { value: 'prospect', emoji: '🔍' },
    { value: 'contract', emoji: '📄' },
    { value: 'invoice', emoji: '🧾' },
    { value: 'payment', emoji: '💳' },
    { value: 'refund', emoji: '↩️' },
    { value: 'discount', emoji: '🏷️' },
    { value: 'offer', emoji: '🎁' },
    { value: 'deal', emoji: '🤝' },
    
    // Mídia e Conteúdo
    { value: 'website', emoji: '🌐' },
    { value: 'social', emoji: '📱' },
    { value: 'blog', emoji: '📝' },
    { value: 'article', emoji: '📰' },
    { value: 'news', emoji: '📰' },
    { value: 'video', emoji: '🎥' },
    { value: 'image', emoji: '🖼️' },
    { value: 'audio', emoji: '🎵' },
    { value: 'podcast', emoji: '🎙️' },
    { value: 'livestream', emoji: '📺' },
    { value: 'webinar', emoji: '🎓' },
    { value: 'course', emoji: '🎓' },
    { value: 'ebook', emoji: '📖' },
    { value: 'whitepaper', emoji: '📄' },
    { value: 'case-study', emoji: '📊' },
    { value: 'infographic', emoji: '📊' },
    { value: 'brochure', emoji: '📋' },
    { value: 'catalog', emoji: '📚' },
    
    // Localização e Logística
    { value: 'location', emoji: '📍' },
    { value: 'office', emoji: '🏢' },
    { value: 'home', emoji: '🏠' },
    { value: 'remote', emoji: '🏡' },
    { value: 'travel', emoji: '✈️' },
    { value: 'delivery', emoji: '🚚' },
    { value: 'shipping', emoji: '📦' },
    { value: 'warehouse', emoji: '🏭' },
    { value: 'store', emoji: '🏪' },
    { value: 'factory', emoji: '🏭' },
    { value: 'supplier', emoji: '🏭' },
    { value: 'vendor', emoji: '🏪' },
    { value: 'partner', emoji: '🤝' },
    { value: 'distributor', emoji: '🚛' },
    { value: 'retailer', emoji: '🏪' },
    { value: 'wholesale', emoji: '📦' },
    { value: 'import', emoji: '📥' },
    { value: 'export', emoji: '📤' },
    { value: 'customs', emoji: '🛂' },
    { value: 'logistics', emoji: '🚛' },
    
    // Tecnologia e Inovação
    { value: 'innovation', emoji: '💡' },
    { value: 'research', emoji: '🔬' },
    { value: 'development', emoji: '🔧' },
    { value: 'prototype', emoji: '🧪' },
    { value: 'pilot', emoji: '✈️' },
    { value: 'beta', emoji: '🧪' },
    { value: 'ai', emoji: '🤖' },
    { value: 'ml', emoji: '🧠' },
    { value: 'blockchain', emoji: '⛓️' },
    { value: 'crypto', emoji: '₿' },
    { value: 'cloud', emoji: '☁️' },
    { value: 'iot', emoji: '🌐' },
    { value: 'ar', emoji: '🥽' },
    { value: 'vr', emoji: '🥽' },
    { value: 'automation', emoji: '🤖' },
    { value: 'integration', emoji: '🔗' },
    { value: 'migration', emoji: '🔄' },
    { value: 'upgrade', emoji: '⬆️' },
    { value: 'downgrade', emoji: '⬇️' },
    { value: 'rollback', emoji: '↩️' },
    
    // Redes Sociais e Plataformas Digitais
    { value: 'facebook', emoji: '📘' },
    { value: 'instagram', emoji: '📷' },
    { value: 'twitter', emoji: '🐦' },
    { value: 'linkedin', emoji: '💼' },
    { value: 'youtube', emoji: '📺' },
    { value: 'tiktok', emoji: '🎵' },
    { value: 'whatsapp', emoji: '💬' },
    { value: 'telegram', emoji: '✈️' },
    { value: 'discord', emoji: '🎮' },
    { value: 'snapchat', emoji: '👻' },
    { value: 'pinterest', emoji: '📌' },
    { value: 'reddit', emoji: '🤖' },
    { value: 'twitch', emoji: '🎮' },
    { value: 'clubhouse', emoji: '🏠' },
    
    // Motores de Busca e Diretórios
    { value: 'google', emoji: '🔍' },
    { value: 'bing', emoji: '🔍' },
    { value: 'yahoo', emoji: '🔍' },
    { value: 'duckduckgo', emoji: '🦆' },
    { value: 'directory', emoji: '📋' },
    { value: 'yellow-pages', emoji: '📞' },
    { value: 'business-directory', emoji: '🏢' },
    
    // Websites e Plataformas Online
    { value: 'website', emoji: '🌐' },
    { value: 'landing-page', emoji: '🎯' },
    { value: 'blog', emoji: '📝' },
    { value: 'ecommerce', emoji: '🛒' },
    { value: 'marketplace', emoji: '🏪' },
    { value: 'amazon', emoji: '📦' },
    { value: 'mercadolivre', emoji: '🛒' },
    { value: 'shopee', emoji: '🛍️' },
    { value: 'magalu', emoji: '🛒' },
    { value: 'americanas', emoji: '🛒' },
    { value: 'submarino', emoji: '🛒' },
    { value: 'netshoes', emoji: '👟' },
    { value: 'dafiti', emoji: '👗' },
    { value: 'zattini', emoji: '👗' },
    { value: 'olx', emoji: '🏠' },
    { value: 'enjoei', emoji: '👗' },
    { value: 'vinted', emoji: '👗' },
    { value: 'depop', emoji: '👗' },
    { value: 'poshmark', emoji: '👗' },
    { value: 'mercari', emoji: '👗' },
    { value: 'grailed', emoji: '👗' },
    { value: 'stockx', emoji: '👟' },
    { value: 'goat', emoji: '👟' },
    { value: 'flightclub', emoji: '👟' },
    { value: 'stadium-goods', emoji: '👟' },
    { value: 'kicks-crew', emoji: '👟' },
    { value: 'sneakersnstuff', emoji: '👟' },
    { value: 'end-clothing', emoji: '👗' },
    { value: 'ssense', emoji: '👗' },
    { value: 'farfetch', emoji: '👗' },
    { value: 'mytheresa', emoji: '👗' },
    { value: 'net-a-porter', emoji: '👗' },
    { value: 'matchesfashion', emoji: '👗' },
    { value: 'luisaviaroma', emoji: '👗' },
    { value: '24s', emoji: '👗' },
    { value: 'selfridges', emoji: '👗' },
    { value: 'harrods', emoji: '👗' },
    { value: 'bergdorf-goodman', emoji: '👗' },
    { value: 'neiman-marcus', emoji: '👗' },
    { value: 'saks-fifth-avenue', emoji: '👗' },
    { value: 'barneys', emoji: '👗' },
    { value: 'nordstrom', emoji: '👗' },
    { value: 'bloomingdales', emoji: '👗' },
    { value: 'macy', emoji: '👗' },
    { value: 'dillards', emoji: '👗' },
    { value: 'belk', emoji: '👗' },
    { value: 'kohls', emoji: '👗' },
    { value: 'jcpenney', emoji: '👗' },
    { value: 'sears', emoji: '👗' },
    { value: 'target', emoji: '🎯' },
    { value: 'walmart', emoji: '🏪' },
    { value: 'costco', emoji: '🏪' },
    { value: 'sams-club', emoji: '🏪' },
    { value: 'bjs', emoji: '🏪' },
    { value: 'kroger', emoji: '🏪' },
    { value: 'safeway', emoji: '🏪' },
    { value: 'publix', emoji: '🏪' },
    { value: 'wegmans', emoji: '🏪' },
    { value: 'whole-foods', emoji: '🏪' },
    { value: 'trader-joes', emoji: '🏪' },
    { value: 'aldi', emoji: '🏪' },
    { value: 'lidl', emoji: '🏪' },
    { value: 'tesco', emoji: '🏪' },
    { value: 'sainsburys', emoji: '🏪' },
    { value: 'asda', emoji: '🏪' },
    { value: 'morrisons', emoji: '🏪' },
    { value: 'waitrose', emoji: '🏪' },
    { value: 'marks-spencer', emoji: '🏪' },
    { value: 'john-lewis', emoji: '🏪' },
    { value: 'debenhams', emoji: '🏪' },
    { value: 'house-of-fraser', emoji: '🏪' },
    { value: 'selfridges', emoji: '🏪' },
    { value: 'harrods', emoji: '🏪' },
    { value: 'liberty', emoji: '🏪' },
    { value: 'fortnum-mason', emoji: '🏪' },
    { value: 'fenwick', emoji: '🏪' },
    { value: 'harvey-nichols', emoji: '🏪' },
    { value: 'liberty-london', emoji: '🏪' },
    { value: 'flannels', emoji: '🏪' },
    { value: 'office', emoji: '🏪' },
    { value: 'schuh', emoji: '👟' },
    { value: 'size', emoji: '👟' },
    { value: 'footlocker', emoji: '👟' },
    { value: 'footaction', emoji: '👟' },
    { value: 'champs-sports', emoji: '👟' },
    { value: 'eastbay', emoji: '👟' },
    { value: 'finish-line', emoji: '👟' },
    { value: 'jimmy-jazz', emoji: '👟' },
    { value: 'sneaker-politics', emoji: '👟' },
    { value: 'atmos', emoji: '👟' },
    { value: 'bait', emoji: '👟' },
    { value: 'social-status', emoji: '👟' },
    { value: 'a-ma-maniere', emoji: '👟' },
    { value: 'kith', emoji: '👟' },
    { value: 'concepts', emoji: '👟' },
    { value: 'packer-shoes', emoji: '👟' },
    { value: 'sneaker-con', emoji: '👟' },
    { value: 'complex', emoji: '👟' },
    { value: 'highsnobiety', emoji: '👟' },
    { value: 'hypebeast', emoji: '👟' },
    { value: 'sneaker-news', emoji: '👟' },
    { value: 'nice-kicks', emoji: '👟' },
    { value: 'sneaker-files', emoji: '👟' },
    { value: 'sneaker-bar', emoji: '👟' },
    
    // Eventos e Conferências
    { value: 'conference', emoji: '🎤' },
    { value: 'seminar', emoji: '🎓' },
    { value: 'workshop', emoji: '🔧' },
    { value: 'training', emoji: '🎓' },
    { value: 'certification', emoji: '📜' },
    { value: 'exhibition', emoji: '🏛️' },
    { value: 'trade-show', emoji: '🏛️' },
    { value: 'expo', emoji: '🏛️' },
    { value: 'fair', emoji: '🎪' },
    { value: 'festival', emoji: '🎪' },
    { value: 'summit', emoji: '🏔️' },
    { value: 'forum', emoji: '💬' },
    { value: 'panel', emoji: '👥' },
    { value: 'keynote', emoji: '🎤' },
    { value: 'presentation', emoji: '📊' },
    { value: 'demo', emoji: '🎬' },
    { value: 'showcase', emoji: '🎭' },
    { value: 'launch', emoji: '🚀' },
    { value: 'release', emoji: '🎊' },
    { value: 'announcement', emoji: '📢' },
    { value: 'press-release', emoji: '📰' },
    { value: 'media-kit', emoji: '📦' },
    { value: 'press-kit', emoji: '📦' },
    { value: 'brand-kit', emoji: '🎨' },
    { value: 'style-guide', emoji: '📐' },
    { value: 'logo', emoji: '🏷️' },
    { value: 'brand', emoji: '🏷️' },
    { value: 'identity', emoji: '🆔' },
    { value: 'guidelines', emoji: '📋' },
    { value: 'standards', emoji: '📏' },
    { value: 'compliance', emoji: '✅' },
    { value: 'audit', emoji: '🔍' },
    { value: 'review', emoji: '👀' },
    { value: 'assessment', emoji: '📊' },
    { value: 'evaluation', emoji: '📈' },
    { value: 'analysis', emoji: '🔬' },
    { value: 'report', emoji: '📄' },
    { value: 'documentation', emoji: '📚' },
    { value: 'manual', emoji: '📘' },
    { value: 'guide', emoji: '🗺️' },
    { value: 'tutorial', emoji: '📖' },
    { value: 'how-to', emoji: '❓' },
    { value: 'faq', emoji: '❓' },
    { value: 'support', emoji: '🆘' },
    { value: 'help', emoji: '🆘' },
    { value: 'contact', emoji: '📞' },
    { value: 'phone', emoji: '📞' },
    { value: 'email', emoji: '📧' },
    { value: 'chat', emoji: '💬' },
    { value: 'message', emoji: '💬' },
    { value: 'notification', emoji: '🔔' },
    { value: 'alert', emoji: '⚠️' },
    { value: 'warning', emoji: '⚠️' },
    { value: 'error', emoji: '❌' },
    { value: 'success', emoji: '🎉' },
    { value: 'info', emoji: 'ℹ️' },
    { value: 'tip', emoji: '💡' },
    { value: 'hint', emoji: '💡' },
    { value: 'suggestion', emoji: '💡' },
    { value: 'recommendation', emoji: '👍' },
    { value: 'feedback', emoji: '💬' },
    { value: 'review', emoji: '⭐' },
    { value: 'rating', emoji: '⭐' },
    { value: 'score', emoji: '📊' },
    { value: 'metric', emoji: '📊' },
    { value: 'kpi', emoji: '📊' },
    { value: 'dashboard', emoji: '📊' },
    { value: 'analytics', emoji: '📊' },
    { value: 'insights', emoji: '💡' },
    { value: 'trends', emoji: '📈' },
    { value: 'patterns', emoji: '🔍' },
    { value: 'correlations', emoji: '🔗' },
    { value: 'relationships', emoji: '🔗' },
    { value: 'connections', emoji: '🔗' },
    { value: 'networks', emoji: '🕸️' },
    { value: 'communities', emoji: '👥' },
    { value: 'groups', emoji: '👥' },
    { value: 'teams', emoji: '👥' },
    { value: 'organizations', emoji: '🏢' },
    { value: 'companies', emoji: '🏢' },
    { value: 'businesses', emoji: '🏢' },
    { value: 'enterprises', emoji: '🏢' },
    { value: 'corporations', emoji: '🏢' },
    { value: 'startups', emoji: '🚀' },
    { value: 'scaleups', emoji: '📈' },
    { value: 'unicorns', emoji: '🦄' },
    { value: 'ipo', emoji: '📈' },
    { value: 'acquisition', emoji: '🤝' },
    { value: 'merger', emoji: '🤝' },
    { value: 'partnership', emoji: '🤝' },
    { value: 'collaboration', emoji: '🤝' },
    { value: 'alliance', emoji: '🤝' },
    { value: 'joint-venture', emoji: '🤝' },
    { value: 'strategic-partnership', emoji: '🤝' },
    { value: 'technology-partnership', emoji: '🤝' },
    { value: 'business-partnership', emoji: '🤝' },
    { value: 'distribution-partnership', emoji: '🤝' },
    { value: 'reseller-partnership', emoji: '🤝' },
    { value: 'channel-partnership', emoji: '🤝' },
    { value: 'vendor-partnership', emoji: '🤝' },
    { value: 'supplier-partnership', emoji: '🤝' },
    { value: 'customer-partnership', emoji: '🤝' },
    { value: 'user-partnership', emoji: '🤝' },
    { value: 'community-partnership', emoji: '🤝' },
    { value: 'ecosystem-partnership', emoji: '🤝' },
    { value: 'platform-partnership', emoji: '🤝' },
    { value: 'integration-partnership', emoji: '🤝' },
    { value: 'api-partnership', emoji: '🤝' },
    { value: 'data-partnership', emoji: '🤝' },
    { value: 'content-partnership', emoji: '🤝' },
    { value: 'marketing-partnership', emoji: '🤝' },
    { value: 'sales-partnership', emoji: '🤝' },
    
    // Ícones básicos (fallback)
    { value: 'tag', emoji: '🏷️' },
    { value: 'star', emoji: '⭐' },
    { value: 'heart', emoji: '❤️' },
    { value: 'flag', emoji: '🚩' },
    { value: 'fire', emoji: '🔥' },
    { value: 'lightning', emoji: '⚡' },
    { value: 'shield', emoji: '🛡️' },
    { value: 'check', emoji: '✅' },
    { value: 'x', emoji: '❌' },
    { value: 'circle', emoji: '⭕' },
    { value: 'square', emoji: '⬜' },
    { value: 'triangle', emoji: '🔺' },
    { value: 'diamond', emoji: '💎' },
    { value: 'hexagon', emoji: '⬡' },
    { value: 'octagon', emoji: '⏸️' },
    { value: 'infinity', emoji: '♾️' },
    { value: 'sos', emoji: '🆘' }
  ]
  

  const icon = availableIcons.find(i => i.value === iconName)
  const emoji = icon ? icon.emoji : '🏷️'
  
  return emoji
}
